'use strict';

angular.module('app')

.run(function (ArticlePage) {}) // jshint ignore:line

.factory('ArticlePage', function (DS) {
    return DS.defineResource({
        name: 'ArticlePage',
        endpoint: 'articlePages',
        upsert: true,
        relations: {
            belongsTo: {
                Article: {
                    localField: 'article',
                    localKey: 'article_id'
                }
            }
        },
    });
});
